import { useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom'

// import styles of this component
import styles from "./App.module.css"

// import other components to use
import Header from './Components/Header/Header';
import MasonryLayout from './Components/MasonryLayout/MasonryLayout';
import ContainerCard from './Components/ContainerCard/ContainerCard';
import Dropdown from './Components/Elements/Dropdown/Dropdown';
import Nav from "./Components/Nav/Nav";
// import something from react packages
import { SearchNormal1 } from "iconsax-react";
import { Setting4 } from "iconsax-react";
import Prompt from "./Jsons/Prompt.json";
import API from "./API"
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import { Divider, Grid, Typography, Card, CardContent, CardHeader, Box, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Link } from "@mui/material";
import Item from "@mui/material/Grid"

import StarBorderIcon from '@mui/icons-material/StarBorder';
import FavoriteIcon from '@mui/icons-material/Favorite'
import RemoveIcon from '@mui/icons-material/Remove'
import { Container, stepButtonClasses } from "@mui/material";
import AppPlayStore from "./Components/AppPlayStore";
import StarIcon from '@mui/icons-material/StarBorder';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// import json files 
import images from "./Jsons/Images.json"


function srcset(image, width, height, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${width * cols}&h=${height * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${width * cols}&h=${height * rows
            }&fit=crop&auto=format&dpr=2 2x`,
    };
}

// App component
const Developer = (props) => {
    const [imageArray, setImageArray] = useState([])
    const [promptText, setPrompt] = useState('')
    const history = useHistory()
    const { prompt } = (props.location && props.location.state) || {};
    const theme = createTheme({
        palette: {
            mode: 'dark',
        }
    },
    );

    async function search() {
        console.log('search')
        let prompt = document.getElementById("prompt").value
        if (prompt == null || prompt.size <= 0) return
        let result = await API.getImagesForPrompt(prompt)
        setImageArray(result.images)
        console.log(result)
    }

    function gotoCreate(promptText) {
        history.push('/create');
    }

    function showMore() {
        var x = document.getElementById("showMore");
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
        x.scrollIntoView()

    }
    async function searchClick(promptText) {
        document.getElementById("prompt").value = promptText
        let result = await API.getImagesForPrompt(promptText)
        setImageArray(result.images)
    }

    return (
        <>
            <Nav />
            {/*<Header /> */}
            <ThemeProvider theme={theme}>
                <Container maxWidth="md" sx={{marginTop:10}}>
                    <Card>
                        <CardHeader
                            title='Creata AI App'
                            subheader='iOS, macOS, Android'
                            titleTypographyProps={{ align: 'center' }}
                            action={<StarIcon />}
                            subheaderTypographyProps={{
                                align: 'center',
                            }}
                            sx={{
                                backgroundColor: (theme) =>
                                    theme.palette.mode === 'light'
                                        ? theme.palette.grey[400]
                                        : theme.palette.grey[700],
                            }}
                        />
                        <CardContent sx={{
                            backgroundColor: 'black'
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'baseline',
                                    mb: 2,
                                }}
                            >

                                <AppPlayStore />
                            </Box>
                        </CardContent>
                    </Card>
                </Container>

                <div width="100%" style={{ marginTop: "50px", padding: '50px' }}>
                    <Box sx={{ marginLeft: 20, marginBottom: 5 }}>
                        <Typography variant="h2" color={'white'}>
                            What's New - Llama Framework
                        </Typography>
                        <Typography variant="h4" color={'white'}>
                            Build your own local GPT Solutions free of Open AI
                        </Typography>
                        <img src="/img/llama_framework_letter_logo.jpg" alt="llama framework" />
                    </Box>
                </div>

                <div style={{ background: '#1d1f21' }}>
                    <Box sx={{ marginLeft: 20, marginBottom: 5, marginTop: 2 }}>
                        <Typography variant="h4" color={'white'} marginBottom={5} marginTop={2}>
                            What is LlamaFramework
                        </Typography>
                        <img src="/img/llamaframework_macos_screen2.jpg" alt="craeta ai llama framework"/>
                        <Typography variant="h6" marginBottom={4}>A swift library that allows the developers to build apps to chat with GPT locally:</Typography>
                                <ListItemText marginLeft={2}>- GPT models runs locally at your computer</ListItemText>
                                <ListItemText>- No Open AI account needed</ListItemText>
                        <ListItemText>- No leaking of your personal info through the chat</ListItemText>
                        <ListItemText>- Xcode project ready to be build</ListItemText>
                        <ListItemText>- Support MacOS and iPhone (very slow & experimental)</ListItemText>
                        <ListItemText>- <Link href="https://github.com/fdchiu/llamaFramework.git">Open Sourced on gitHub</Link></ListItemText>

                        <Button variant="contained" href='https://github.com/fdchiu/llamaFramework.git' sx={{ marginTop: "20px" }}>Learn More</Button>
                    </Box>
                </div>
                <Container maxWidth="100%">
                    {imageArray != undefined || imageArray.length > 0 ?
                        (
                            <ImageList
                                sx={{
                                    //width: '100%',
                                    //height: 450,
                                    // Promote the list into its own layer in Chrome. This costs memory, but helps keeping high FPS.
                                    padding: 20,
                                    transform: 'translateZ(0)',
                                }}
                                rowHeight={512}
                                gap={50}
                            >
                                {imageArray.map((item) => {
                                    const cols = 6; //item.featured ? 2 : 1;
                                    const rows = 2; //item.featured ? 2 : 1;

                                    return (
                                        <ImageListItem key={item.src} cols={cols} rows={rows}>
                                            <img
                                                {...srcset(item.src, item.width, item.height, rows, cols)}
                                                alt={item.prompt}
                                                loading="lazy"
                                            />
                                            <ImageListItemBar
                                                sx={{
                                                    background:
                                                        'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                                        'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                                                    width: '75%',
                                                    margin: 'auto',
                                                    wordWrap: 'breakWord',
                                                    whiteSpace: 'preWrap'
                                                }}
                                                title='creatAI' //{item.model}
                                                subtitle={item.prompt}
                                                position="bottom"
                                                actionIcon={[
                                                    <IconButton
                                                        id='logo'
                                                        sx={{ color: 'white' }}
                                                        aria-label={`favorite ${item.prompt}`}
                                                        onClick={() => searchClick(item.prompt)}
                                                    >
                                                        {/*<FavoriteIcon />*/}
                                                        <img src='/img/logo.png' id='logoimg' width='40' height='40'></img>
                                                    </IconButton>
                                                ]}
                                                actionPosition="left"
                                            />
                                        </ImageListItem>
                                    );
                                })}
                            </ImageList>
                        )
                        :
                        <div></div>
                    }
                </Container>
            </ThemeProvider>
        </>
    )
}

export default Developer